export enum EventRelationship {
    Owner = 0,
    Shared = 1,
    Participant = 2,
}
